import type React from "react"
import { Typography, Container } from "@mui/material"
import makeStyles from "@mui/styles/makeStyles"
import Footer from "../sections/Footer2"
import FadeIn from "../sections/FadeIn"

const useStyles = makeStyles((theme) => ({
  touch: {
    marginTop: "50px",
    color: "#FFF",
    fontWeight: 700,
    fontSize: "4em",
    textAlign: "center",
    marginBottom: "20px",
    fontFamily: "ui-serif",
  },
}))

const Refund: React.FC = () => {
  const classes = useStyles()
  return (
    <>
      <div>
        <FadeIn>
          <Typography className={classes.touch} style={{ color: "Black" }}>
            Refund and Cancellation Policy
          </Typography>
        </FadeIn>
        <Container
          style={{
            textAlign: "left",
            color: "#000000",
            fontSize: "20px",
            fontWeight: 400,
            marginTop: "50px",
            marginBottom: "100px",
            // fontFamily: "Roboto",
          }}
        >
          <div>
            We, <strong>M/s.AiM4u Software Solutions Pvt.Ltd</strong>
            (hereinafter referred to as the "<strong>Company</strong>") having its registered office at 8th Floor,
            SP-TBI, Munshi Nagar,Andheri (W), Mumbai, Maharashtra 400058 represented by its members, where such
            expression shall, unless repugnant to the context thereof, be deemed to include its respective legal heirs,
            representatives, administrators, permitted successors and assigns. This refund and cancellation policy
            outlines how you can cancel or seek a refund for a product / service that you have purchased/booked through
            the Platform.
          </div>
          <div>&nbsp;</div>
          <div>
            This Refund and Cancellation Policy shall be in compliance with the applicable laws in effect from June 20,
            2023 and any and all provisions that may read to the contrary shall be deemed to be void and unenforceable
            as of that date. If you do not agree with the terms and conditions of our Refund and Cancellation Policy,
            please do not use or access the Site. If you have any questions or concerns regarding this Refund and
            Cancellation Policy, you should contact our Customer Support Desk at support@aim4u.co.in
          </div>
          <div>&nbsp;</div>
          <div>
            ANY CAPITALIZED WORDS USED HENCEFORTH SHALL HAVE THE MEANING ACCORDED TO THEM UNDER THIS AGREEMENT. FURTHER,
            ALL HEADING USED HEREIN ARE ONLY FOR THE PURPOSE OF ARRANGING THE VARIOUS PROVISIONS OF THE AGREEMENT IN ANY
            MANNER. NEITHER THE USER NOR THE CREATERS OF THIS REFUND AND CANCELLATION POLICY MAY USE THE HEADING TO
            INTERPRET THE PROVISIONS CONTAINED WITHIN IT IN ANY MANNER.
          </div>
          <div>
            <strong>&nbsp;</strong>
          </div>
          <ol>
            <strong>
              <li>REFUND POLICY:</li>
            </strong>
          </ol>
          <div>Under this policy:</div>
          <ol type="a">
            <li>
              If you are eligible for a refund, the refunded amount will be credited back to the original payment method
              within 7 days. Processing times may vary depending on your bank or payment provider.
            </li>
          </ol>
          <div>
            <strong>&nbsp;</strong>
          </div>
          <ol start={2}>
            <strong>
              <li>CANCELLATION POLICY</li>
            </strong>
          </ol>
          <div>
            Cancellations will only be considered if the request is made within 7 days of placing the order/booking.
            However, cancellation requests may not be entertained if the orders/booking have been communicated to such
            sellers / merchant(s) listed on the Platform and they have initiated the process of shipping/consulting
            them. The customer service team at AIM4U SOFTWARE SOLUTIONS PVT LTD after looking into your complaint will
            take an appropriate decision.
          </div>
          <div>&nbsp;</div>
          <ol start={3}>
            <strong>
              <li>ELIGIBILITY FOR REFUNDS</li>
            </strong>
          </ol>
          <div>Refunds may be issued in the following circumstances:</div>
          <ol type="a">
            <li>Services not rendered as described or promised</li>
            <li>Technical issues preventing access to purchased digital products</li>
            <li>Duplicate charges or billing errors</li>
            <li>Other circumstances as determined by the Company on a case-by-case basis</li>
          </ol>
          <div>&nbsp;</div>
          <ol start={4}>
            <strong>
              <li>REFUND PROCESS</li>
            </strong>
          </ol>
          <div>
            To request a refund, please contact our customer support team at support@aim4u.co.in with the following
            information:
          </div>
          <ol type="a">
            <li>Your full name and contact information</li>
            <li>Order/booking reference number</li>
            <li>Date of purchase</li>
            <li>Reason for requesting a refund</li>
            <li>Any relevant supporting documentation</li>
          </ol>
          <div>Our team will review your request and respond within 48 business hours.</div>
          <div>&nbsp;</div>
          <ol start={5}>
            <strong>
              <li>NON-REFUNDABLE ITEMS</li>
            </strong>
          </ol>
          <div>The following items or services are generally not eligible for refunds:</div>
          <ol type="a">
            <li>Services that have been fully delivered or completed</li>
            <li>Digital products that have been downloaded or accessed</li>
            <li>Customized or personalized products</li>
            <li>Products or services clearly marked as non-refundable at the time of purchase</li>
          </ol>
          <div>&nbsp;</div>
          <ol start={6}>
            <strong>
              <li>CANCELLATION PROCESS</li>
            </strong>
          </ol>
          <div>
            To cancel an order or booking, please contact our customer support team at support@aim4u.co.in as soon as
            possible with your order details. Remember that cancellations must be requested within 7 days of placing the
            order/booking.
          </div>
          <div>&nbsp;</div>
          <ol start={7}>
            <strong>
              <li>AMENDMENT</li>
            </strong>
          </ol>
          <div>
            Our Refund and Cancellation Policy may change from time to time. The most current version of the policy will
            govern our use of your information and will always be available on the Website.
          </div>
          <div>&nbsp;</div>
          <ol start={8}>
            <strong>
              <li>CONTACT US</li>
            </strong>
          </ol>
          <div>
            If you have any questions or concerns regarding this refund and cancellation policy, you should contact us
            by sending an e-mail to support@aim4u.co.in
          </div>
        </Container>
      </div>
      <Footer />
    </>
  )
}

export default Refund

